// (function (Drupal, drupalSettings) {
//   Drupal.behaviors.header = {
//     attach: function (context, settings) {
//       const mainHeader = context.querySelector(".main-header");
//       const toggleSearch = context.querySelector(".toggle-search");
//       const searchBloc = context.querySelector(".search-bloc");
//       const mainMenu = context.querySelector(".main-menu");
//       const body = document.body;

//       if (mainHeader && !mainHeader.dataset.headerProcessed) {
//         mainHeader.dataset.headerProcessed = "true";

//         let lastScrollTop = 0;

//         window.addEventListener("scroll", () => {
//           const scrollTop = window.scrollY;

//           if (scrollTop > 60) {
//             mainHeader.classList.add("scrolled");
//           } else {
//             mainHeader.classList.remove("scrolled");
//           }

//           if (scrollTop > lastScrollTop) {
//             mainHeader.classList.remove("scrollUp");
//             mainHeader.classList.add("scrollDown");
//           } else {
//             mainHeader.classList.remove("scrollDown");
//             mainHeader.classList.add("scrollUp");
//           }

//           lastScrollTop = scrollTop;
//         });

//         if (toggleSearch && searchBloc) {
//           toggleSearch.addEventListener("click", (e) => {
//             e.preventDefault();
//             e.stopPropagation();
//             searchBloc.classList.toggle("open");
//           });

//           document.addEventListener("click", () => {
//             searchBloc.classList.remove("open");
//           });

//           searchBloc.addEventListener("click", (e) => {
//             e.stopPropagation();
//           });
//         }

//         const searchInputs = context.querySelectorAll(".form-search");
//         searchInputs.forEach((input) => {
//           input.addEventListener("focusin", () => {
//             input.parentElement.classList.add("focusin");
//           });

//           input.addEventListener("focusout", () => {
//             input.parentElement.classList.remove("focusin");
//             input.value = "";
//           });
//         });

//         const searchForm = context.querySelector(".search-block-form");
//         if (searchForm) {
//           const searchButton = document.createElement("button");
//           searchButton.className = "search-btn";
//           searchForm
//             .querySelector(".form-actions input")
//             .insertAdjacentElement("beforebegin", searchButton);

//           const submitButton = searchForm.querySelector(".form-actions button");
//           if (submitButton) {
//             submitButton.addEventListener("click", () => {
//               searchForm.submit();
//             });
//           }
//         }

//         if (mainMenu) {
//           const toggleMenu = context.querySelector(".toggle-menu");
//           if (toggleMenu) {
//             toggleMenu.addEventListener("click", (e) => {
//               e.preventDefault();
//               toggleMenu.classList.toggle("open");
//               body.classList.toggle("menu-open");
//             });
//           }

//           const expandedMenuItems = mainMenu.querySelectorAll(
//             "ul li.menu-item--expanded > a, ul li.menu-item--expanded > span"
//           );
//           expandedMenuItems.forEach((item) => {
//             item.addEventListener("click", (e) => {
//               e.preventDefault();
//               e.stopPropagation();

//               const parentLi = item.parentElement;
//               mainMenu.querySelectorAll("ul li").forEach((li) => {
//                 if (li !== parentLi) {
//                   li.classList.remove("hovered");
//                 }
//               });

//               parentLi.classList.toggle("hovered");
//             });
//           });

//           document.addEventListener("click", () => {
//             mainMenu
//               .querySelectorAll("ul > li")
//               .forEach((li) => li.classList.remove("hovered"));
//           });
//         }
//       }
//     },
//   };
// })(Drupal, drupalSettings);

(function (Drupal, drupalSettings) {
  Drupal.behaviors.header = {
    attach: function (context, settings) {
      const mainHeader = context.querySelector(".main-header");
      const toggleSearch = context.querySelector(".toggle-search");
      const searchBloc = context.querySelector(".search-bloc");
      const mainMenu = context.querySelector(".main-menu");
      const body = document.body;

      if (mainHeader && !mainHeader.dataset.headerProcessed) {
        mainHeader.dataset.headerProcessed = "true";

        let lastScrollTop = 0;

        window.addEventListener("scroll", () => {
          const scrollTop = window.scrollY;

          if (scrollTop > 60) {
            mainHeader.classList.add("scrolled");
          } else {
            mainHeader.classList.remove("scrolled");
          }

          if (scrollTop > lastScrollTop) {
            mainHeader.classList.remove("scrollUp");
            mainHeader.classList.add("scrollDown");
          } else {
            mainHeader.classList.remove("scrollDown");
            mainHeader.classList.add("scrollUp");
          }

          lastScrollTop = scrollTop;
        });

        if (toggleSearch && searchBloc) {
          toggleSearch.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            searchBloc.classList.toggle("open");
          });

          document.addEventListener("click", () => {
            searchBloc.classList.remove("open");
          });

          searchBloc.addEventListener("click", (e) => {
            e.stopPropagation();
          });
        }

        const searchInputs = context.querySelectorAll(".form-search");
        searchInputs.forEach((input) => {
          input.addEventListener("focusin", () => {
            input.parentElement.classList.add("focusin");
          });

          input.addEventListener("focusout", () => {
            input.parentElement.classList.remove("focusin");
            input.value = "";
          });
        });

        const searchForm = context.querySelector(".search-block-form");
        if (searchForm) {
          const searchButton = document.createElement("button");
          searchButton.className = "search-btn";
          searchForm
            .querySelector(".form-actions input")
            .insertAdjacentElement("beforebegin", searchButton);

          const submitButton = searchForm.querySelector(".form-actions button");
          if (submitButton) {
            submitButton.addEventListener("click", () => {
              searchForm.submit();
            });
          }
        }

        if (mainMenu) {
          const toggleMenu = context.querySelector(".toggle-menu");
          if (toggleMenu) {
            toggleMenu.addEventListener("click", (e) => {
              e.preventDefault();
              toggleMenu.classList.toggle("open");
              body.classList.toggle("menu-open");
            });
          }

          const expandedMenuItems = mainMenu.querySelectorAll(
            "ul li.menu-item--expanded > a, ul li.menu-item--expanded > span"
          );

          expandedMenuItems.forEach((item) => {
            item.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();

              const parentLi = item.parentElement;

              // Vérifier si l'élément cliqué est déjà actif
              const isOpen = parentLi.classList.contains("hovered");

              // Fermer uniquement les autres menus qui ne sont pas dans la hiérarchie de l'élément cliqué
              mainMenu
                .querySelectorAll("ul li.menu-item--expanded")
                .forEach((li) => {
                  if (!li.contains(parentLi)) {
                    li.classList.remove("hovered");
                  }
                });

              // Si l'élément n'était pas ouvert, on l'ouvre
              if (!isOpen) {
                parentLi.classList.add("hovered");
              }
            });
          });

          // Empêche la fermeture du menu lorsqu'on clique à l'intérieur
          mainMenu.addEventListener("click", (e) => {
            e.stopPropagation();
          });

          // Ferme le menu uniquement si on clique en dehors
          document.addEventListener("click", (e) => {
            if (!mainMenu.contains(e.target)) {
              mainMenu
                .querySelectorAll("ul > li")
                .forEach((li) => li.classList.remove("hovered"));
            }
          });
        }
      }
    },
  };
})(Drupal, drupalSettings);
